import { all, takeEvery } from 'redux-saga/effects';
import { fetchVolumeOptionsAction } from '../actions';
import { fetchVolumeOptionsSaga } from './fetchVolumeOptionsSaga';

export function* volumeOptionsWatcherSaga() {
  yield all([takeEvery(fetchVolumeOptionsAction.TYPE, fetchVolumeOptionsSaga)]);
}
